/*
 *  I21RENDETASCalcul.js
 *
 *  Created by Sébastien Hecart on 2019-01-18 01:08:09 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { I21RENDETAS_State } from '@batical/types/src'

function I21RENDETAS_docalcul(state: I21RENDETAS_State) {
  state.invalidated = false
  //TODO CALCUL
  state.res_F1 = 3
  // Hotfix 2.5.0 F2 =2,5*(0,15*D10+0,85*D11+1,3*D12)/(0,85*D16+0,15*D15)*100
  state.res_F2 =
    ((2.5 * (0.15 * state.in_puissance30 + 0.85 * state.in_puissance100 + 1.3 * state.in_puissanceArret)) /
      (0.85 * state.in_puissanceMin + 0.15 * state.in_puissanceMax)) *
    100
  state.res_F3 = ((0.5 * state.in_perteArret) / state.in_puissanceMax) * 100
  state.res_F4 = (1.3 * state.in_puissanceVeilleuse) / state.in_puissanceMin
  state.res_somme = state.res_F1 + state.res_F2 + state.res_F3 + state.res_F4
  //Hotfix 2.5.0 =0,85*D8+0,15*D9
  state.res_rendementSon = 0.85 * state.in_rendement30PCS + 0.15 * state.in_rendement100PCS
  state.res_rendement = state.res_rendementSon - state.res_somme
  return state
}

export default I21RENDETAS_docalcul

// export type I21RENDETAS_State = {
// 	in_rendement30PCI: number.
// 	in_rendement100PCI: number.
// 	in_rendement30PCS: number.
// 	in_rendement100PCS: number.
// 	in_puissance30: number.
// 	in_puissance100: number.
// 	in_puissanceArret: number.
// 	in_perteArret: number.
// 	in_puissanceVeilleuse: number.
// 	in_puissanceMin: number.
// 	in_puissanceMax: number.
// 	res_F1: number.
// 	res_F2: number.
// 	res_F3: number.
// 	res_F4: number.
// 	res_somme: number.
// 	res_rendementSon: number.
// 	res_rendement: number.
// }& CalculContext_State;
